import PropTypes from 'prop-types';

const computedColors = [];
const colors = ['white', 'melrose', 'facebook'];
const shadedColors = ['grey', 'purple', 'orange', 'red', 'green'];
const shades = ['10', '20', '30', '40', '50', '60', '70'];

computedColors.push(...colors);

shadedColors.forEach((color) => {
    shades.forEach((shade) => {
        if (color === 'grey' || color === 'purple') {
            computedColors.push(`${color}--${shade}`);
        }
        if (color === 'orange' && shade !== '70') {
            computedColors.push(`${color}--${shade}`);
        }
        if ((color === 'red' || color === 'green')
            && shade !== '40'
            && shade !== '50'
            && shade !== '60'
            && shade !== '70'
        ) {
            computedColors.push(`${color}--${shade}`);
        }
    });
});

const computedSpaces = [];
const spaces = ['a', '0', '1', '2', '3', '4', '5', '6'];
const sizes = ['xs', 's', 'm', 'l', 'xl'];
const orientations = ['r', 'l', 'b', 't', 'x', 'y'];

spaces.forEach((space) => computedSpaces.push(`-${space}`));

orientations.forEach((orientation) => {
    spaces.forEach((space) => {
        computedSpaces.push(`${orientation}-${space}`);
        sizes.forEach((size) => {
            computedSpaces.push(`${orientation}--${size}-${space}`);
        });
    });
});

const marginOrientations = computedSpaces.map((computedSpace) => `m${computedSpace}`);
const paddingOrientations = computedSpaces.map((computedSpace) => `p${computedSpace}`);

const computedColSpaces = [];
const colSpaces = ['auto', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
const colSizes = ['xs', 's', 'm', 'l', 'xl'];

computedColSpaces.push(...colSpaces);

colSpaces.forEach((space) => {
    colSizes.forEach((size) => {
        computedColSpaces.push(`${size}-${space}`);
    });
});

export const commonPropTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string,
    ]),
    className: PropTypes.string,
    componentClass: PropTypes.oneOfType([
        PropTypes.any,
        PropTypes.string,
        PropTypes.element,
        PropTypes.object,
    ]),
    ypUtils: PropTypes.shape({
        background: PropTypes.oneOf(computedColors),
        border: PropTypes.oneOf(['grey', 'green', 'red']),
        borderRadius: PropTypes.oneOf(['0', '2', '4', '6', '8', '10', '14', '16', '20', '30', '40', '50', '100']),
        col: PropTypes.oneOf(computedColSpaces),
        colPush: PropTypes.bool,
        color: PropTypes.oneOf(computedColors),
        cursor: PropTypes.oneOf(['pointer', 'move']),
        display: PropTypes.oneOf(['inline-block', 'block', 'none']),
        flex: PropTypes.bool,
        float: PropTypes.oneOf(['left', 'right', 'none']),
        margin: PropTypes.arrayOf(PropTypes.oneOf(marginOrientations)),
        order: PropTypes.oneOf(['first', 'last']),
        padding: PropTypes.arrayOf(PropTypes.oneOf(paddingOrientations)),
        position: PropTypes.oneOf(['relative', 'absolute']),
        textAlign: PropTypes.oneOf(['left', 'right', 'center']),
        tips: PropTypes.oneOf(['bottom']),
        width: PropTypes.oneOf(['full']),
    }),
};

export const commonDefaultProps = {
    children: [],
    className: '',
    componentClass: 'div',
    ypUtils: {},
};

export const concatClassNames = (arrayOfClassNames) => (
    arrayOfClassNames.filter((className) => className.length > 0).join(' ')
);

const splitStringColPush = (str) => {
    if (str.length > 2 && str !== 'auto') {
        const arrayOfSplitedString = str.split('-');
        return `${arrayOfSplitedString[0]}-push-${arrayOfSplitedString[1]}`;
    }
    return `push-${str}`;
};

const concatClassNamesOfSpaces = (array) => (
    array.reduce((prevClassName, currClassName) => `${prevClassName} ${currClassName}`, '')
);

export const ypUtilsToClassNames = (ypUtils) => ([
    ypUtils.background ? `u-bg__${ypUtils.background}` : '',
    ypUtils.border ? `border-${ypUtils.border}` : '',
    ypUtils.borderRadius ? `br${ypUtils.borderRadius}` : '',
    ypUtils.col ? `u-col-${ypUtils.col.length > 2 && ypUtils.col !== 'auto' ? '-' : ''}${ypUtils.colPush ? splitStringColPush(ypUtils.col) : ypUtils.col}` : '',
    ypUtils.color ? `u-color__${ypUtils.color}` : '',
    ypUtils.cursor ? `u-${ypUtils.cursor === 'pointer' ? 'clickable' : ''}${ypUtils.cursor === 'move' ? ypUtils.cursor : ''}` : '',
    ypUtils.display ? `u-display__${ypUtils.display === 'inline-block' ? `ib dis_${ypUtils.display}` : ''}${ypUtils.display === 'block' ? `b dis_${ypUtils.display}` : ''}${ypUtils.display === 'none' ? ypUtils.display : ''}` : '',
    ypUtils.flex ? 'u-flex--1' : '',
    ypUtils.float ? `u-float_${ypUtils.float}` : '',
    ypUtils.margin ? `${concatClassNamesOfSpaces(ypUtils.margin)}` : '',
    ypUtils.order ? `u-order-${ypUtils.order}` : '',
    ypUtils.padding ? `${concatClassNamesOfSpaces(ypUtils.padding)}` : '',
    ypUtils.position ? `pos_${ypUtils.position}` : '',
    ypUtils.textAlign ? `u-text-align__${ypUtils.textAlign}` : '',
    ypUtils.tips ? `u-tips u-tips--${ypUtils.tips}` : '',
    ypUtils.width ? `u-width--${ypUtils.width}` : '',
]);

/*
 * Remove props contained by PropTypes to avoid React warning about invalid html attributes
 */
export const filterProps = (propTypes, props) => {
    const filteredProps = {};
    Object.entries(props).forEach(([propKey, propValue]) => {
        if (!Object.keys(propTypes).includes(propKey)) {
            filteredProps[propKey] = propValue;
        }
    });
    return filteredProps;
};
